import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  ViewEncapsulation,
} from "@angular/core";
import { Router } from "@angular/router";
import { WatchlistPageService } from "src/app/watchlist-page/watchlist-page.service";
import { Observable } from "rxjs";
import { WatchlistData } from "../watchlist-page.model";
import { DeleteWatchlistData } from "src/app/store/actions/global.actions";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/store/state/app.state";
import {
  VAIconRegistryService,
  exclamationTriangle,
} from "@va/core-library/icons";
@Component({
  selector: "app-manage-watchlist-modal",
  templateUrl: "./manage-watchlist-modal.component.html",
  styleUrls: ["./manage-watchlist-modal.component.scss"],
  host: { class: "manage-watchlist-component" },
  encapsulation: ViewEncapsulation.None,
})
export class ManageWatchlistModalComponent implements OnInit {
  @Input() visible: boolean;
  @Output() onClose: EventEmitter<boolean> = new EventEmitter();

  watchlistData: any = [];
  modalWidth: string;
  modalHeight: string;
  userId: string;
  apiUrl: string = window.apiUrl;
  checked = false;
  indeterminate = false;
  listOfData: WatchlistData[] = [];
  checkedIds = new Set<number>();
  dataObservable: Observable<any>;
  showDeleteConfirmationModal = false;
  legacyUrl = `${window.caUrl}/app`;
  storeDataKey = "watchlist";

  constructor(
    private router: Router,
    private service: WatchlistPageService,
    private store: Store<AppState>,
    private iconRegistryService: VAIconRegistryService,
  ) {
    this.iconRegistryService.registerIcons([exclamationTriangle]);
  }

  ngOnInit() {
    this.modalWidth = "560px";
  }

  ngOnChanges() {
    //because api is getting called while closing modal as well
    if (this.visible) {
      this.getWatchlists();
    }
  }

  getWatchlists() {
    this.service.getWatchlistsForUser().subscribe(
      (respObject: any) => {
        if (respObject.status !== "failure") {
          this.watchlistData = respObject.data;
        }
      },
      function error(errObject) {
        throw errObject;
      },
    );
  }

  updateCheckedSet(id: number, checked: boolean): void {
    checked ? this.checkedIds.add(id) : this.checkedIds.delete(id);
  }

  refreshCheckedStatus(): void {
    this.checked = this.watchlistData.every((item) =>
      this.checkedIds.has(item.w_id),
    );
    this.indeterminate =
      this.watchlistData.some((item) => this.checkedIds.has(item.w_id)) &&
      !this.checked;
  }

  onRowChecked(id: number, checked: boolean): void {
    this.updateCheckedSet(id, checked);
    this.refreshCheckedStatus();
  }

  onCheckAll(value: boolean): void {
    this.watchlistData.forEach((item) =>
      this.updateCheckedSet(item.w_id, value),
    );
    this.refreshCheckedStatus();
  }

  handleCancelModal() {
    this.visible = false;
    this.resetStates();
    this.onClose.emit(true);
  }

  showWarningModal() {
    if (this.checkedIds.size > 0) {
      this.showDeleteConfirmationModal = true;
    }
  }

  handleDeleteModalCancel() {
    this.showDeleteConfirmationModal = false;
  }

  resetStates() {
    this.checkedIds.clear();
    this.indeterminate = false;
    this.refreshCheckedStatus();
  }

  deleteSelectedWatchlists() {
    if (this.checkedIds.size > 0) {
      const postData = {
        watcherid: [...this.checkedIds],
      };
      this.service.deleteWatchlistidsForUser(postData).subscribe(
        (respObject: any) => {
          if (respObject.status !== "failure") {
            this.deleteWatchlistFromStore();
            this.handleCancelModal();
            this.handleDeleteModalCancel();
            // if user is on watchlist page, then take him to first watchlist
            if (window.location.pathname.split("/")[1] === "watchlist") {
              this.router.navigateByUrl(`/watchlist`);
            }
          }
        },
        function error(errObject) {
          throw errObject;
        },
      );
    }
  }

  deleteWatchlistFromStore() {
    const payload = {
      ids: [...this.checkedIds],
      key: this.storeDataKey,
    };
    this.store.dispatch(new DeleteWatchlistData(payload));
  }
}
